export const RATE_NEGOTIATION_LIST_PATH = "shift-negotiations";
export const RATE_NEGOTIATION_LIST_PATH_FULL = `/home-v2/${RATE_NEGOTIATION_LIST_PATH}`;
